import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  Input,
  HostListener,
} from "@angular/core";
import { LocationType } from "../models/location-type";
import { StandardService } from "../services/standard.service";
import { Category } from "../models/category";
import { StandardType } from "../models/standardType";
import { FilteringGuide } from "../models/filteringGuide";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";
import { Addendum } from "../models/addendum";
import { AddendumList } from "../models/addendum-list";
import { AddendumStatus } from "../models/addendumStatus";
import { Country } from "../models/country";
import { Constant, UserRoleEnum, AddendumStatusEnum } from "../core/constant";
import { sortWithSelectedFirst, shouldShowSelectedDivider } from "../core/filter-utils";
import { AddendumService } from "../services/addendum.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-exceptions-filter",
  templateUrl: "./exceptions-filter.component.html",
  styleUrl: "./exceptions-filter.component.scss",
})
export class ExceptionsFilterComponent implements OnInit {

  exportFilterList: FilteringGuide[] = [];
  ExportselectedCountryIds: number[] = [];
  isExportStatusDropdownOpen: boolean = false;
  isExportCountryDropdownOpen: boolean = false;

  isExportModalOpen: boolean = false;


  searchKey: string = "";
  isStatusDropdown: boolean = false;
  statusSearchText: string = "";
  filteredStatuses: any[] = [];

  isCountryDropdownOpen: boolean = false;
  countrySearchText: string = "";
  filteredCountries: any[] = [];

  locationTypes: LocationType[] = [];
  categories: Category[] = [];
  standardTypes: StandardType[] = [];
  filteringForCheckBox: FilteringGuide[] = [];

  userRole: number = 2; // 1 -> Global Admin , 2 -> Market Admin
  page: number = 1;
  pageSize: number = 5;
  collectionSize: number = 0;
  pageSizes: any[] = Constant.PageSizes;

  addendums: Addendum[] = [];
  countries: Country[] = [];
  addendumStatuses: AddendumStatus[] = [];
  error: string = "";
  selectedCountryIds: number[] = [];
  countryId: Array<number> = [];
  loading: boolean = false;
  filterList: number[] = [];


  @Output() selectedFilter = new EventEmitter<Array<any>>();
  @Output() searchApplied = new EventEmitter<string>();
   @Output() countrySelected = new EventEmitter<any>()
  @Input() searchKeyFromParent: string = "";
  /** Country filter already applied by the parent (e.g. persisted from before
   *  navigating away and back) - restored into the UI instead of resetting to
   *  "All Countries" on re-init. */
  @Input() initialCountryIds: number[] = [];
    @Output() exportListFilter = new EventEmitter<Array<FilteringGuide>>();
  @Output() countryListFilter = new EventEmitter<any>();
  constructor(
    private addendumService: AddendumService,
    private standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
  ) {}

  ngOnInit() {
    this.userRole = this.getEffectiveUserRole();
    this.getMasterDataForAddendum().subscribe();
  }

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  showCountryFilter(): boolean {
    return this.getEffectiveUserRole() !== UserRoleEnum.MarketAdmin;
  }

  getEffectiveCountryIds(): number[] {
    const sessionCountryId = sessionStorage.getItem("selectedCountryID");
    if (sessionCountryId) {
      return [Number(JSON.parse(sessionCountryId))];
    }

    const stored = this.cryptographyService.decryptData(
      this.storage.get("countryId"),
    );
    return Array.isArray(stored) ? stored : [stored];
  }

  getMasterDataForAddendum(): Observable<any> {
    this.loading = true;
    return new Observable<any>((observer) => {
      this.addendumService
        .getMasterDataForAddendum(
          this.getEffectiveUserRole(),
          this.cryptographyService.decryptData(this.storage.get("userId")),
        )
        .subscribe((data: any) => {
          this.countries = data.countries;
          this.addendumStatuses = data.addendumStatuses;
          this.setFilteredCountries([...this.countries]);
          this.setFilteredStatuses([...this.addendumStatuses]);

          if (!this.showCountryFilter()) {
            const countryIds = this.getEffectiveCountryIds();
            this.countries = this.countries.filter((country) =>
              countryIds.includes(country.id),
            );
            this.setFilteredCountries([...this.countries]);
            if (this.countries.length) {
              this.selectedCountryIds = [this.countries[0].id];
            }
          } else if (
            this.initialCountryIds?.length &&
            !this.initialCountryIds.includes(0)
          ) {
            this.selectedCountryIds = [...this.initialCountryIds];
            this.setFilteredCountries([...this.countries]);
          } else {
            // No filter applied yet - default to "All Countries" selected.
            this.selectedCountryIds = [this.getAllCountriesId()];
            this.setFilteredCountries([...this.countries]);
          }

          this.loading = false;
          observer.next(undefined);
        });
    });
  }
  addOrRemoveFilter($event, id, name, type) {
    this.sendAuthEvent(name, id, type, $event.checked);
    this.pageSize = 5;
    this.page = 1;

    if ($event.checked) {
      if (!this.filterList.includes(id)) {
        this.filterList.push(id);
      }
    } else {
      this.filterList.splice(this.filterList.indexOf(id), 1);
    }
    this.standardService.equipmentAddendumFiltration.filter = this.filterList;
    console.log("filter lsit",this.filterList)
    if (this.isStatusDropdown) {
      this.filterStatus();
    }
  }

  private setFilteredStatuses(items: any[]): void {
    this.filteredStatuses = sortWithSelectedFirst(items, (id) =>
      this.setCheckedStateForCheckBoxes(id),
    );
  }

  private setFilteredCountries(items: any[]): void {
    this.filteredCountries = sortWithSelectedFirst(
      items,
      (id) => this.selectedCountryIds.includes(id),
    );
  }

  private setExportFilteredStatuses(items: any[]): void {
    this.filteredStatuses = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(1, id),
    );
  }

  private setExportFilteredCountries(items: any[]): void {
    this.filteredCountries = sortWithSelectedFirst(items, (id) =>
      this.ExportselectedCountryIds.includes(id),
    );
  }

  applyFilters() {
    this.selectedFilter.emit(
      this.filterList,
    );
    this.isStatusDropdown = false;
  }

  clearStatusFilters(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.filterList = [];
    this.statusSearchText = "";
    this.standardService.equipmentAddendumFiltration.filter = this.filterList;
    this.setFilteredStatuses([...this.addendumStatuses]);
    this.isStatusDropdown = false;
    this.selectedFilter.emit(this.filterList);
  }

  setCheckedStateForCheckBoxes(id) {
    return this.filterList.includes(id);
  }

  async sendAuthEvent(filterName, filterID, filterType, isChecked) {
    this.standardService
      .recordSearchEvent([
        {
          eventType: "GRSFilters",
          filterName: filterName,
          filterID: filterID,
          filterType: filterType,
          isChecked: isChecked,
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
        },
      ])
      .subscribe({ next: () => void 0, error: () => void 0 });
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Close status dropdown
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isStatusDropdown = false;
    }

    // Close country dropdown
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isCountryDropdownOpen = false;
    }
  
  }

  onSearch(key: any) {
    this.searchKey = typeof key === "string" ? key : key?.value || "";
    this.searchApplied.emit(this.searchKey);
  }

    toggleDropdown(dropdownType: "country" | "status" ) {
    // Close all dropdowns first

      if (dropdownType === "country") {
        this.isStatusDropdown = false;  
    } else if (dropdownType === "status") {
        this.isCountryDropdownOpen = false;  
    }

    // Open the requested dropdown

    switch (dropdownType) {
      case "country":
        this.isCountryDropdownOpen = !this.isCountryDropdownOpen;

        this.countrySearchText = "";

        this.setFilteredCountries([...this.countries]);

        break;

      case "status":
        this.isStatusDropdown =  !this.isStatusDropdown;

        this.statusSearchText = "";

        this.setFilteredStatuses([...this.addendumStatuses]);

        break;

       
    }
  }


 getSelectedItemsCount(type: "status" | "country"): any {
  if (type === "country") {
    return this.selectedCountryIds
      .map((id) => this.countries.find((c) => c.id === id)?.name)
      .filter(Boolean);
  }

  let items: any[] = [];
  let filterType: number;

  if (type === "status") {
    items = this.addendumStatuses;
    filterType = 1; // Assuming status uses filter type 1
  }

  // Filter items that are selected
  const selectedItems = items.filter((item) =>
    this.filterList.includes(item.id)
  );

  return selectedItems.map((item) => item.name);
}

// Single display text function
getDisplayText(type: "status" | "country"): string {
  const selected = this.getSelectedItemsCount(type);

  if (!selected || selected.length === 0) return "";

  if (selected.length === 1) return `: ${selected[0]}`;

  return `: ${selected[0]} +${selected.length - 1}`;
}

 filterStatus() {
    const searchTerm = this.statusSearchText.toLowerCase();
    this.setFilteredStatuses(
      this.addendumStatuses.filter((item) =>
        item.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  filterCountries() {
    const searchTerm = this.countrySearchText.toLowerCase();
    this.setFilteredCountries(
      this.countries.filter((country) =>
        country.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  isCountryFilterChecked(countryId: number): boolean {
    return this.selectedCountryIds.includes(countryId);
  }

  onCountryFilterChange(event: any, countryId: number): void {
    const isAll = this.isAllCountriesItem(countryId);

    if (event.checked) {
      if (isAll) {
        this.selectedCountryIds = [countryId];
      } else {
        this.selectedCountryIds = this.selectedCountryIds.filter(
          (id) => !this.isAllCountriesItem(id),
        );
        if (!this.selectedCountryIds.includes(countryId)) {
          this.selectedCountryIds.push(countryId);
        }
      }
    } else {
      const index = this.selectedCountryIds.indexOf(countryId);
      if (index >= 0) {
        this.selectedCountryIds.splice(index, 1);
      }
      if (this.selectedCountryIds.length === 0) {
        this.selectedCountryIds = [this.getAllCountriesId()];
      }
    }

    if (this.isCountryDropdownOpen) {
      this.filterCountries();
    }
  }

  applyCountryFilters(): void {
    this.isCountryDropdownOpen = false;
    this.countrySelected.emit([...this.selectedCountryIds]);
  }

  shouldShowMainCountryClearButton(): boolean {
    if (!this.selectedCountryIds.length) {
      return false;
    }
    if (this.selectedCountryIds.length === 1) {
      return !this.isAllCountriesItem(this.selectedCountryIds[0]);
    }
    return true;
  }

  shouldShowMainCountryFilterHighlight(): boolean {
    return (
      this.getSelectedItemsCount("country").length > 0 &&
      this.shouldShowMainCountryClearButton()
    );
  }

  removeMainCountrySelection(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.selectedCountryIds = [this.getAllCountriesId()];
    this.countrySearchText = "";
    this.setFilteredCountries([...this.countries]);
    this.isCountryDropdownOpen = false;
    this.countrySelected.emit([...this.selectedCountryIds]);
  }

  private isAllCountriesItem(countryId: number): boolean {
    if (countryId === 0) {
      return true;
    }
    const country = this.countries?.find((c) => c.id === countryId);
    return country?.name?.toLowerCase() === "all countries";
  }

  private getAllCountriesId(): number {
    const allObj = this.countries?.find(
      (c) => c.id === 0 || c.name?.toLowerCase() === "all countries",
    );
    return allObj ? allObj.id : 0;
  }








  
  onExportClick() {
    // this.exportFilterList.emit(this.exportFilterList);
  }

  openExportModal() {
    this.isExportModalOpen = !this.isExportModalOpen;
  }
  closeExportModal() {
    this.isExportModalOpen = false;
    this.isExportStatusDropdownOpen = false;
    this.isExportCountryDropdownOpen = false;
  }

  toggleExportDropdown(dropdownType: "status" | "country") {
    // Close all other dropdowns first
    if (dropdownType !== "status") {
      this.isExportStatusDropdownOpen = false;
    }
    if (dropdownType !== "country") {
      this.isExportCountryDropdownOpen = false;
    }
   

    // Toggle the requested dropdown
    switch (dropdownType) {
      case "status":
        this.isExportStatusDropdownOpen = !this.isExportStatusDropdownOpen;
        if (this.isExportStatusDropdownOpen) {
          this.setExportFilteredStatuses([...this.addendumStatuses]);
        }
        break;

     
      case "country":
        this.isExportCountryDropdownOpen = !this.isExportCountryDropdownOpen;
        if (this.isExportCountryDropdownOpen) {
          this.setExportFilteredCountries([...this.countries]);
        }
        break;
    }
  }

  setExportCheckedStateForCheckBoxes(type, id): boolean {
    if (this.exportFilterList != null && this.exportFilterList.length > 0) {
      let t = this.exportFilterList.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
    return false;
  }

  getExportSelectedItemsCount(
    type: "status"  | "country",
  ): any {
    let items: any[];
    let checkboxType: number;

    if (type === "status") {
      items = this.addendumStatuses;
      checkboxType = 1;
    } 

    return items
      .filter((item) =>
        this.setExportCheckedStateForCheckBoxes(checkboxType, item.id),
      )
      .map((item) => item.name);
  }

  getExportDisplayText(type: "status" | "country"): string {
    const selected = this.getExportSelectedItemsCount(type);

    if (selected.length === 0) return "";
    if (selected.length === 1) return `${selected[0]}`;
    return `${selected[0]} +${selected.length - 1}`;
  }

  // Apply export filters and pass to API
  applyExportFilters() {
    console.log("Applied Export Filters:", this.exportFilterList);
    console.log("Selected Country IDs:", this.ExportselectedCountryIds);

    this.countryListFilter.emit(this.ExportselectedCountryIds.length > 0 ? this.ExportselectedCountryIds : []);
    this.exportListFilter.emit(this.exportFilterList);

    this.closeExportModal();
    this.exportFilterList = [];
    this.ExportselectedCountryIds = [];
  }

  addExportFilter($event, id, filterParam, name, type) {
    if ($event.checked) {
      let filterGuide = this.exportFilterList.find(
        (i) => i.type === filterParam,
      );
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.exportFilterList.push(guide);
      }
    } else {
      let selectedFilter = this.exportFilterList.find(
        (i) => i.type === filterParam,
      );
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter && selectedFilter.ids.length == 0) {
        let i = this.exportFilterList.findIndex((x) => x.type === filterParam);
        if (i > -1) {
          this.exportFilterList.splice(i, 1);
        }
      }
    }
    if (filterParam === 1 && this.isExportStatusDropdownOpen) {
      this.setExportFilteredStatuses([...this.addendumStatuses]);
    }
  }

  onCountrySelectionChange(event: any, countryId: any) {
    if (event.checked) {
      // Add to selected IDs if not already present
      if (!this.ExportselectedCountryIds.includes(countryId)) {
        this.ExportselectedCountryIds.push(countryId);
      }
    } else {
      // Remove from selected IDs
      const index = this.ExportselectedCountryIds.indexOf(countryId);
      if (index > -1) {
        this.ExportselectedCountryIds.splice(index, 1);
      }
    }
    console.log("Selected Country IDs:", this.ExportselectedCountryIds);
    if (this.isExportCountryDropdownOpen) {
      this.setExportFilteredCountries([...this.countries]);
    }
  }
  isCountrySelected(countryId: any): boolean {
    return this.ExportselectedCountryIds.includes(countryId);
  }

  getCountryDisplayText(): string {
    const country = this.filteredCountries.find(
      (c) => c.id === this.ExportselectedCountryIds[0],
    );

    if (this.ExportselectedCountryIds.length === 1) {
      return country.name;
    }

    return `${country.name} +${this.ExportselectedCountryIds.length - 1}`;
  }

  showStatusFilterDivider(items: any[], index: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.setCheckedStateForCheckBoxes(id),
    );
  }

  showCountryFilterDivider(items: any[], index: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.selectedCountryIds.includes(id),
    );
  }

  showExportStatusFilterDivider(items: any[], index: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.setExportCheckedStateForCheckBoxes(1, id),
    );
  }

  showExportCountryFilterDivider(items: any[], index: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.isCountrySelected(id),
    );
  }
}
